// eslint-disable-next-line no-restricted-imports
import {path} from 'ramda';

export const getThemeToken = <Value>(theme: object, key: string): Value | '' =>
  path<Value>(key.split('.'), theme) ?? '';
